import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import taxiOfficerEditUserPermissionsDefinition from "./taxi-officer-edit-user-permission";

const useTaxiOfficerEditUserPermissions = () => {
  return useUserPermissions(taxiOfficerEditUserPermissionsDefinition);
};

export default useTaxiOfficerEditUserPermissions;
